import { createRouter, createWebHistory } from 'vue-router'

import Layout from '@/layout/index.vue'

export const constantRoutes = [
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true,
    meta: { 
      title: 'Авторизуйтесь',
      layout: "login",
      permission: 'noauth' // ТОЛЬКО НЕ АВТОРИЗОВАННЫЙ ПОЛЬЗОВАТЕЛЬ
    }
  },
  {
    name: 'privacy',
    path: '/privacy',
    component: () => import('@/views/login/privacy.vue'),
    hidden: true,
    meta: { 
      title: 'Согласие на обработку персональных данных', 
      layout: "login",
      permission: 'all'
    }
  },
  {
    name: 'installApp',
    path: '/installApp',
    component: () => import('@/views/common/install-app.vue'),
    hidden: true,
    meta: { 
      title: 'Как установить приложение', 
      layout: "login",
      permission: 'all'
    }
  },
  {
    name: 'resetPassword',
    path: '/reset-password',
    component: () => import('@/views/login/reset-password.vue'),
    hidden: true,
    meta: { 
      title: 'Сменить пароль', 
      layout: "login",
      permission: 'noauth'
    }
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/error-page/404.vue'),
    hidden: true,
    meta: { 
      title: 'Страница не найдена',
      layout: "login",
      permission: 'all'
    }
  },
  {
    name: '401',
    path: '/401',
    component: () => import('@/views/error-page/401.vue'),
    hidden: true,
    meta: { 
      title: 'Вам недоступна данная страница',
      layout: "login",
      permission: 'all'
    }
  },
  {
    name: '403',
    path: '/403',
    component: () => import('@/views/error-page/403.vue'),
    hidden: true,
    meta: { 
      title: 'Вам недоступна данная страница',
      layout: "login",
      permission: 'all' // ЛЮБОЙ ПОЛЬЗОВАТЕЛЬ
    }
  },
  {
    name: 'main',
    path: '/',
    //component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { 
          title: 'Рабочий стол', 
          layout: "index",
          permission: 'auth'  // ТОЛЬКО АВТОРИЗОВАННЫЙ ПОЛЬЗОВАТЕЛЬ
        }
      }
    ]
  },
  {
    name: 'Contract',
    path: '/contract',
    //component: Layout,
    redirect: '/contract/index',
    meta: { title: 'Договоры' },
    children: [
      {
        name: 'ContractList',
        path: 'index',
        component: () => import('@/views/contract/index.vue'),
        meta:{ 
          permission: 'auth',
          layout: "index",
          title: 'Договоры' 
        },
      },
      {
        name: 'ContractView',
        path: '/contract/:id',
        component: () => import('@/views/contract/view.vue'),
        meta:{ 
          permission: 'auth',
          layout: "index",
          title: 'Договор' 
        },
      }
    ]
  },
  {
    name: 'Counter',
    path: '/counter',
    //component: Layout,
    redirect: '/counter/index',
    meta: { title: 'Приборы учета' },
    children: [
      {
        name: 'CounterList',
        path: 'index',
        component: () => import('@/views/counter/index.vue'),
        meta:{ 
          permission: 'auth',
          layout: "index",
          title: 'Приборы учета' 
        },
      },
      {
        name: 'CounterValues',
        path: 'values',
        component: () => import('@/views/counter/values.vue'),
        meta:{ 
          permission: 'auth',
          layout: "index",
          title: 'Передать показания' 
        },
      },
      {
        name: 'CounterView',
        path: '/counter/:id',
        component: () => import('@/views/counter/view.vue'),
        meta:{ 
          permission: 'auth',
          layout: "index",
          title: 'Прибор учета' 
        },
      }
    ]
  },
  {
    name: 'Requests',
    path: '/requests',
    //component: Layout,
    redirect: '/requests/index',
    meta: { title: 'Обращения' },
    children: [
      {
        name: 'RequestList',
        path: 'index',
        component: () => import('@/views/requests/index.vue'),
        meta:{ 
          permission: 'auth',
          layout: "index",
          title: 'Обращения' 
        },
      },
      {
        name: 'RequestView',
        path: '/requests/:id',
        component: () => import('@/views/requests/view.vue'),
        meta:{ 
          permission: 'auth',
          layout: "index",
          title: 'Обращение' 
        },
      },
      {
        name: 'RequestAdd',
        path: '/requests/add',
        component: () => import('@/views/requests/form.vue'),
        meta:{ 
          permission: 'auth',
          layout: "index",
          title: 'Создать обращение' 
        },
      }
    ]
  },
  {
    name: 'Profile',
    path: '/profile',
    //component: Layout,
    redirect: '/profile/view',
    meta: { title: 'Пользователь' },
    children: [
      {
        name: 'ProfileView',
        path: 'view',
        component: () => import('@/views/profile/index.vue'),
        meta:{ 
          permission: 'auth', 
          layout: "index",
          title: 'Профиль пользователя' 
        },
      },
      {
        name: 'NoticeView',
        path: 'notice',
        component: () => import('@/views/profile/notice.vue'),
        meta:{ 
          permission: 'auth', 
          layout: "index",
          title: 'Уведомления' 
        },
      },
    ]
  },

  { path: '/:catchAll(.*)', name: 'CatchAll', redirect: '/404', hidden: true }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  scrollBehavior: () => ({ top: 0 }),
  routes: constantRoutes
})

export default router
